import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const NARROW_SCREEN_QUERY = "(max-width: 640px)";
const SELECTED_BOX_MIN_WIDTH = "260px";
const RESULT_ICON_SIZE = "20px";
const IMPORT_BUTTON_BACKGROUND_HOVER = projectIqTokens.tealInk;

export const useImportEngagementItemsStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    marginTop: designTokens.spacing[2],
    fontFamily: projectIqTokens.fontFamily,
  },
  heading: {
    margin: 0,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },
  description: {
    margin: 0,
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink3,
    lineHeight: String(designTokens.lineHeight.normal),
  },
  card: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[5]}`,
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
    [NARROW_SCREEN_QUERY]: {
      padding: designTokens.spacing[3],
    },
  },
  selectedRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  selectedBox: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    flex: "1 1 " + SELECTED_BOX_MIN_WIDTH,
    minWidth: 0,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    backgroundColor: projectIqTokens.tealSoft,
    border: `1px solid ${projectIqTokens.tealLine}`,
    borderRadius: designTokens.borderRadius.md,
  },
  selectedInfo: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
  },
  selectedNameRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: designTokens.spacing[2],
    minWidth: 0,
  },
  selectedName: {
    margin: 0,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  selectedFolder: {
    margin: 0,
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.ink3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  importButton: {
    backgroundColor: projectIqTokens.teal,
    flexShrink: 0,
    ":hover:not(:disabled)": {
      backgroundColor: IMPORT_BUTTON_BACKGROUND_HOVER,
    },
  },
  resultRegion: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    ":empty": {
      marginTop: `calc(-1 * ${designTokens.spacing[3]})`,
    },
  },
  resultRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[3],
    paddingTop: designTokens.spacing[3],
    borderTop: `1px solid ${projectIqTokens.line}`,
  },
  resultIcon: {
    flexShrink: 0,
    display: "inline-flex",
    fontSize: RESULT_ICON_SIZE,
    marginTop: "1px",
  },
  resultIconSuccess: {
    color: designTokens.semantic.successDark,
  },
  resultIconWarning: {
    color: designTokens.semantic.warningText,
  },
  resultIconError: {
    color: designTokens.semantic.error,
  },
  resultBody: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    flex: 1,
    minWidth: 0,
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink2,
  },
  resultTitle: {
    fontWeight: designTokens.fontWeight.bold,
  },
  resultTitleSuccess: {
    color: designTokens.semantic.successDark,
  },
  resultTitleWarning: {
    color: designTokens.semantic.warningText,
  },
  resultTitleError: {
    color: designTokens.semantic.error,
  },
  resultWarningText: {
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.semantic.warningText,
  },
  resultExplanation: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.ink3,
    lineHeight: String(designTokens.lineHeight.normal),
  },
  sparkleIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    color: projectIqTokens.amber,
  },
  errorText: {
    margin: 0,
    fontSize: designTokens.fontSize.sm,
    color: designTokens.semantic.error,
  },
});
